import { Label, UnfilledError } from 'components';
import { BodyProps } from 'constants/MultipleAcorddions';
import React, { memo, useContext, useEffect, useState } from 'react';
import { Flex, Box } from '@chakra-ui/react';
import { colors } from 'theme/colors';
import { ConclusionMessage, ConclusionResponses } from 'pages/Private/Evaluation/components';
import { evaluationCtx } from '../../index';
import { useParams } from 'react-router-dom';
import { getEvaluationFinishPosition } from 'services/evaluationConclusion';

interface IProps extends BodyProps {
  unfilledSteps: string[];
}
interface IParams {
  id: string;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ConclusionsComponent: React.FC<IProps> = ({ index, functionCallback, unfilledSteps }) => {
  const params = useParams<IParams>();
  const ctx = useContext(evaluationCtx);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { load, setIsLoad } = useContext(evaluationCtx);

  const [unfilledStepRef, setUnfilledStepRef] = useState<string[]>([]);
  const unfilled: number[] = [1, 2, 3, 4, 5, 6, 7];

  const unfilledStep: string[] = [
    '1 - Dados Pessoais',
    '2 - Natureza dos dados',
    '3 - Propósitos',
    '4 - Aspectos do tratamento',
    '5 - Agentes Envolvidos',
    '6 - Impactos',
    '7 - Aspectos Técnicos',
  ];

  // eslint-disable-next-line prefer-const
  let unfilledStepsRef: string[] = [];

  const getFormConclusions = async (finishForm: number) => {
    const id = Number(params.id);
    const response = await getEvaluationFinishPosition(finishForm, id);

    if (!response.data) {
      if (unfilledStep[finishForm - 1][0] === String(finishForm)) {
        unfilledStepsRef.push(unfilledStep[finishForm - 1]);
      }
    } else {
      const index = unfilledStepsRef.indexOf(unfilledStep[finishForm - 1]);
      if (index > -1) unfilledStepsRef.splice(index, 1);
    }
    setUnfilledStepRef([...unfilledStepsRef]);
  };

  useEffect(() => {
    // eslint-disable-next-line no-extra-boolean-cast
    if (!!params.id && !load) {
      if (
        (ctx.data.status === 'DONE' &&
          (unfilledSteps.length !== 0 || unfilledStepsRef.length !== 0)) ||
        ctx.data.status === 'DRAFT'
      ) {
        unfilled.forEach(item => {
          getFormConclusions(item);
        });
      }
    }
  }, [load]);

  if (params.id) {
    if (unfilledStepRef.length > 0) {
      return <UnfilledError unfilledSteps={unfilledStepRef.sort()} />;
    }
  }

  if (unfilledStepRef.length === 0) {
    if (params.id) {
      return (
        <Flex marginTop="0.5rem" width="100%" direction="column">
          {ctx.results ? (
            <Box>
              <Box>
                <Label color={colors.brand[900]}>Grau de risco preliminar do projeto</Label>
                {ctx.results?.risk ? (
                  <ConclusionMessage
                    type={
                      ctx.results?.risk.message === 'RISCO ALTO'
                        ? 'error'
                        : ctx.results?.risk.message === 'RISCO MÉDIO'
                        ? 'warning'
                        : 'approve'
                    }
                    mt="12px"
                  />
                ) : null}
              </Box>
              <Box mt="37px" mb="30px">
                <Label color={colors.brand[900]}>Demais recomendações</Label>
              </Box>
              {ctx.results?.recomendations.abroad ? (
                <Box>
                  <ConclusionResponses
                    text={ctx.results?.recomendations?.abroad?.message || ''}
                    error={ctx.results?.recomendations?.abroad?.color === 'alert-danger'}
                    titulo="Tranferências internacionais"
                  />
                </Box>
              ) : null}
              {ctx.results?.recomendations.legalBase ? (
                <Box>
                  <ConclusionResponses
                    text={ctx.results?.recomendations?.legalBase?.message || ''}
                    error={ctx.results?.recomendations?.legalBase?.color === 'alert-danger'}
                    titulo="Base legal"
                  />
                </Box>
              ) : null}
              {ctx.results?.recomendations.personalData ? (
                <Box>
                  <ConclusionResponses
                    text={ctx.results?.recomendations?.personalData?.message || ''}
                    error={ctx.results?.recomendations?.personalData?.color === 'alert-danger'}
                    titulo="Dados pessoais"
                  />
                </Box>
              ) : null}
              {ctx.results?.recomendations.retentionData ? (
                <Box>
                  <ConclusionResponses
                    text={ctx.results?.recomendations?.retentionData?.message || ''}
                    error={ctx.results?.recomendations?.retentionData?.color === 'alert-danger'}
                    titulo="Retenção de dados"
                  />
                </Box>
              ) : null}
              {ctx.results?.recomendations.securityMeasure ? (
                <Box>
                  <ConclusionResponses
                    text={ctx.results?.recomendations?.securityMeasure?.message || ''}
                    error={ctx.results?.recomendations?.securityMeasure?.color === 'alert-danger'}
                    titulo="Medidas de segurança"
                  />
                </Box>
              ) : null}
              {ctx.results?.recomendations.thirtyParties ? (
                <Box>
                  <ConclusionResponses
                    text={ctx.results?.recomendations?.thirtyParties?.message || ''}
                    error={ctx.results?.recomendations?.thirtyParties?.color === 'alert-danger'}
                    titulo="Contratos com terceiros"
                  />
                </Box>
              ) : null}
            </Box>
          ) : (
            <Label>Conclua a avaliação primeiro!</Label>
          )}
        </Flex>
      );
    }
  }

  if (ctx.unfilledSteps.length > 0) {
    return <UnfilledError unfilledSteps={ctx.unfilledSteps} />;
  }

  return (
    <Flex marginTop="0.5rem" width="100%" direction="column">
      {ctx.results ? (
        <Box>
          <Box>
            <Label color={colors.brand[900]}>Grau de risco preliminar do projeto</Label>
            {ctx.results?.risk ? (
              <ConclusionMessage
                type={
                  ctx.results?.risk.message === 'RISCO ALTO'
                    ? 'error'
                    : ctx.results?.risk.message === 'RISCO MÉDIO'
                    ? 'warning'
                    : 'approve'
                }
                mt="12px"
              />
            ) : null}
          </Box>
          <Box mt="37px" mb="30px">
            <Label color={colors.brand[900]}>Demais recomendações</Label>
          </Box>
          {ctx.results?.recomendations.abroad ? (
            <Box>
              <ConclusionResponses
                text={ctx.results?.recomendations?.abroad?.message || ''}
                error={ctx.results?.recomendations?.abroad?.color === 'alert-danger'}
                titulo="Tranferências internacionais"
              />
            </Box>
          ) : null}
          {ctx.results?.recomendations.legalBase ? (
            <Box>
              <ConclusionResponses
                text={ctx.results?.recomendations?.legalBase?.message || ''}
                error={ctx.results?.recomendations?.legalBase?.color === 'alert-danger'}
                titulo="Base legal"
              />
            </Box>
          ) : null}
          {ctx.results?.recomendations.personalData ? (
            <Box>
              <ConclusionResponses
                text={ctx.results?.recomendations?.personalData?.message || ''}
                error={ctx.results?.recomendations?.personalData?.color === 'alert-danger'}
                titulo="Dados pessoais"
              />
            </Box>
          ) : null}
          {ctx.results?.recomendations.retentionData ? (
            <Box>
              <ConclusionResponses
                text={ctx.results?.recomendations?.retentionData?.message || ''}
                error={ctx.results?.recomendations?.retentionData?.color === 'alert-danger'}
                titulo="Retenção de dados"
              />
            </Box>
          ) : null}
          {ctx.results?.recomendations.securityMeasure ? (
            <Box>
              <ConclusionResponses
                text={ctx.results?.recomendations?.securityMeasure?.message || ''}
                error={ctx.results?.recomendations?.securityMeasure?.color === 'alert-danger'}
                titulo="Medidas de segurança"
              />
            </Box>
          ) : null}
          {ctx.results?.recomendations.thirtyParties ? (
            <Box>
              <ConclusionResponses
                text={ctx.results?.recomendations?.thirtyParties?.message || ''}
                error={ctx.results?.recomendations?.thirtyParties?.color === 'alert-danger'}
                titulo="Contratos com terceiros"
              />
            </Box>
          ) : null}
        </Box>
      ) : (
        <Label>Conclua a avaliação primeiro!</Label>
      )}
    </Flex>
  );
};

export const Conclusions = memo(ConclusionsComponent);
